import {ParsedUrlParams} from "./urlparams";

export default class EmailChannel {

    public static is(parsed: ParsedUrlParams) {
        if (typeof(parsed['utm_medium']) === 'undefined') {
            return false;
        }
        const utmMedium = parsed['utm_medium'];
        if (utmMedium) {
            // check the first utm medium for channel grouping
            const checkMedium = utmMedium[0];
            return checkMedium.toLocaleLowerCase() === 'email';
        }
        return false;
    }

}